import React, { useState, useEffect } from "react";
import { updateData } from "../../utility/adminApi";
import CancelIcon from "@mui/icons-material/Cancel";
import SelectLabels from "../../components/SelectLabels";
import { adminAxios } from "../../axiosInstance";
function EditUser({
  singleData,
  setSingleData,
  fetchUsers,
  setEdittab,
  currentPage,
}) {
  // const [loading, setLoading] = useState(false);
  const [roleDetail, setRoleDetail] = useState();
  const [, setLoading] = useState(false);
  const previousValue = singleData.roles[0].id;
  const fetchProductData = async (page) => {
    setSingleData((prevData) => ({ ...prevData, role_id: previousValue }));

    try {
      const response = await adminAxios.get("roles");
      const data = response?.data?.data;
      setRoleDetail(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRowChange = (id) => {
    setSingleData((prevData) => ({ ...prevData, role_id: id }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // Log singleData before submission to check its content

    const keysToExtract = [
      "firstname",
      "lastname",
      "email",
      "address",
      "phoneno",
      "role_id",
    ];
    const newSingleData = Object.keys(singleData)?.reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    const response = await updateData(
      "users/update/",
      singleData.id,
      newSingleData
    );

    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchUsers(currentPage);
      setEdittab(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setEdittab(false)}
        />
      </div>

      <h2 className="text-2xl font-medium text-center">Edit User </h2>
      <form
        onSubmit={handleEditSubmit}
        className="py-12  flex flex-wrap justify-center items-center gap-6 "
      >
        <div className="flex  flex-col lg:w-[400px]">
          <label htmlFor="">Roles</label>
          <SelectLabels
            categoryData={roleDetail}
            text="Select a Role"
            valueKey="id"
            labelKey="name"
            onSelectChange={handleRowChange}
            previousValue={previousValue}
          />
        </div>
        <div className="flex 1/2 flex-col">
          <label htmlFor="">Email</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="Email"
            type="text "
            name="email"
            // id="email"
            value={singleData?.email}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="">First Name</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="First Name"
            type="text "
            name="firstname"
            // id="email"
            value={singleData?.firstname}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="">Last Name</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="Last Name"
            type="text "
            name="lastname"
            // id="email"
            value={singleData?.lastname}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="">Address</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="Address"
            type="text "
            name="address"
            // id="email"
            value={singleData?.address}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="">Phone Number</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="Phone Number"
            type="text "
            name="phoneno"
            // id="email"
            value={singleData?.phoneno}
            onChange={handleChange}
          />
        </div>

        <button
          // disabled={loading}
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {/* {loading ? "Saving..." : "Save Product"} */}
          Update
        </button>
      </form>
      {/* <ToastContainer /> */}
    </div>
  );
}

export default EditUser;
